module.exports = __webpack_public_path__ + "_assets/img/ticket.ec965e07.svg";